<template>
  <nav class="filter-container" ref="containerRef">
    <hr class="pill" :style="{ transform: `translateX(${pillPosition}px)`, width: `${pillWidth}px` }" />
    <slot :setActiveFilter="setActiveFilter" :activeFilter="activeFilter" />
  </nav>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue'

const props = defineProps({ modelValue: { type: String, default: '' } })
const emit = defineEmits(['update:modelValue'])

const activeFilter = ref(props.modelValue)
const pillPosition = ref(0)
const pillWidth = ref(0)
const containerRef = ref(null)

const setActiveFilter = (value) => {
  activeFilter.value = value
  emit('update:modelValue', value)
  nextTick(() => {
    const button = containerRef.value?.querySelector(`[value="${value}"]`)
    if (button) {
      pillPosition.value = button.offsetLeft - 4
      pillWidth.value = button.offsetWidth
    }
  })
}

onMounted(() => {
  const initialValue = activeFilter.value || containerRef.value?.querySelector('button')?.getAttribute('value') || ''
  setActiveFilter(initialValue)
})
</script>

<style scoped>
@import '@/css/breakpoints.css';

nav {
  top: -14rem;
  position: absolute; ;
  font-size: 1.2rem;
  z-index: 1;
  margin-left: -0.25rem;
}


@media (--phone) {
  nav {
    top: -10rem;    
    left: -0.5rem;
  }
}




.filter-container {
  position: relative;
  display: inline-flex;
  background-color: rgba(26, 26, 26, 1);
  border-radius: 10rem;
  padding: 0.25rem;
}

hr.pill {
  border: none;
  outline: none;
  margin: 0;
  padding: 0;
  display: block;
  position: absolute;
  top: 0.25rem;
  bottom: 0.25rem;
  border-radius: 10rem;
  background-color: rgba(49, 49, 49, 1);
  transition: transform 0.3s ease-in-out, width 0.3s ease-in-out;
  z-index: 1;
}

:deep(button) {
  position: relative;
  cursor: pointer;
  background-color: transparent;
  outline: none;
  color: inherit;
  font-family: inherit;
  margin: 0;
  padding: 0.75rem 1.5rem;
  border: none;
  font-weight: 400;
  text-transform: uppercase;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: inherit;
  border-radius: 10rem;
  z-index: 2;
  transition: transform 0.1s ease-in-out, color 0.3s ease-in-out;
  text-align: center;
}

:deep(button:hover) {
  color: white;
  background-color: transparent;
}

:deep(button:active) {
  color: gray;
}

:deep(button.active) {
  color: white;
}
</style>
